"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decDrCapped = exports.incDrCapped = exports.drToSF = exports.sfToDR = exports.isShoutyDevice = exports.getRssiRangeForDr = exports.getDrForRssi = exports.isDataRate = exports.isSpreadingFactor = exports.DefaultULtoACKDLRatio = exports.LoRaRSSIUnknownValue = void 0;
const Validation_1 = require("../../Validation");
exports.LoRaRSSIUnknownValue = 127;
exports.DefaultULtoACKDLRatio = 10;
const SpreadingFactors = [7, 8, 9, 10, 11, 12];
const isSpreadingFactor = (value) => (0, Validation_1.isNonNaNNumber)(value) && SpreadingFactors.includes(value);
exports.isSpreadingFactor = isSpreadingFactor;
const DataRates = [0, 1, 2, 3, 4, 5];
const isDataRate = (value) => (0, Validation_1.isNonNaNNumber)(value) && DataRates.includes(value);
exports.isDataRate = isDataRate;
const drRSSIBreakpoints = {
    5: [-93, -50], // SF7
    4: [-96, -93], // SF8
    3: [-99, -96], // SF9
    2: [-102, -99], // SF10
    1: [-104, -102], // SF11
    0: [-107, -104], // SF12
};
const getDrForRssi = (rssi) => {
    for (const [dr, [lo, hi]] of Object.entries(drRSSIBreakpoints)) {
        if (rssi >= lo && rssi < hi) {
            return parseInt(dr);
        }
    }
    return 0; // If RSSI is below all breakpoints, return lowest DR
};
exports.getDrForRssi = getDrForRssi;
const getRssiRangeForDr = (dr) => {
    return drRSSIBreakpoints[dr];
};
exports.getRssiRangeForDr = getRssiRangeForDr;
const SF_DR = {
    7: 5,
    8: 4,
    9: 3,
    10: 2,
    11: 1,
    12: 0,
};
/** returns true if the signal is better (rssi is higher) than the lower limit of the next higher DR RSSI range */
const isShoutyDevice = (rssi, sf, logger) => {
    const actualDr = (0, exports.sfToDR)(sf);
    const higherDr = (0, exports.incDrCapped)(actualDr);
    const higherDrRssiRange = (0, exports.getRssiRangeForDr)(higherDr);
    const lowerLimitForHigherDr = higherDrRssiRange[0];
    if (logger) {
        logger.info(`Determining if device is shouty with RSSI ${rssi} and SF ${sf} (implied DR ${actualDr})`, { rssi, sf, actualDr, higherDr, higherDrRssiRange, lowerLimitForHigherDr }),
            logger.info(`comparing against lower limit of next higher DR ${higherDr} which is ${lowerLimitForHigherDr}`);
    }
    return rssi >= lowerLimitForHigherDr;
};
exports.isShoutyDevice = isShoutyDevice;
const sfToDR = (sf) => SF_DR[sf];
exports.sfToDR = sfToDR;
const drToSF = (dr) => {
    const sfEntry = Object.entries(SF_DR).find(([_, drVal]) => drVal === dr);
    if (!sfEntry) {
        throw new Error(`Invalid DR value ${dr}, must be between 0 and 5`);
    }
    return parseInt(sfEntry[0]);
};
exports.drToSF = drToSF;
const incDrCapped = (dr) => Math.min(dr + 1, 5);
exports.incDrCapped = incDrCapped;
const decDrCapped = (dr) => Math.max(dr - 1, 0);
exports.decDrCapped = decDrCapped;
